import { shouldEnableSensitiveData } from '@/apps/hr/src/lib/request/utils/hr-feature-flags';

export type ListColumns = Record<ListColumnsKeys, ListColumnsNames>;
export type ListColumnsKeys = keyof typeof LIST_COLUMNS;
export type ListColumnsNames = typeof LIST_COLUMNS[keyof typeof LIST_COLUMNS];

export const LIST_COLUMNS_INDEXED = {
  Company: 'COMPANY',
  Active: 'ACTIVE',
  Email: 'EMAIL',
  Mobile: 'MOBILE',
  StressProfile: 'STRESS_PROFILE',
  Training: 'TRAINING',
  Rate: 'RATE',
  PayrollId: 'PAYROLL',
  LeaveBalance: 'LEAVE_BALANCE',
  'connected-to': 'CONNECTED_TO',
} as const;

export const LIST_COLUMNS = {
  COMPANY: 'Company',
  ACTIVE: 'Active',
  EMAIL: 'Email',
  MOBILE: 'Mobile',
  STRESS_PROFILE: 'StressProfile',
  TRAINING: 'Training',
  RATE: 'Rate',
  PAYROLL: 'PayrollId',
  LEAVE_BALANCE: 'LeaveBalance',
  CONNECTED_TO: 'connected-to',
} as const;

export const LIST_COLUMNS_DEFAULT_VISIBLE = [LIST_COLUMNS.RATE];

export const LIST_COLUMNS_PERMISSIONS: Record<ListColumnsKeys, string[]> = {
  RATE: shouldEnableSensitiveData()
    ? ['Can_Manage_Employee_PayDetails', 'Can_View_Hr_Sensitive_Info']
    : ['Can_Manage_Employee_PayDetails'],
  PAYROLL: shouldEnableSensitiveData()
    ? ['Can_Manage_Employee_PayDetails', 'Can_View_Hr_Sensitive_Info']
    : ['Can_Manage_Employee_PayDetails'],
  LEAVE_BALANCE: ['Can_Manage_Employee_PayDetails'],
  COMPANY: [],
  ACTIVE: [],
  EMAIL: [],
  MOBILE: [],
  STRESS_PROFILE: [],
  TRAINING: [],
  CONNECTED_TO: [],
};

export function getColumnKeyByValue(index: ListColumnsNames): ListColumnsKeys {
  return LIST_COLUMNS_INDEXED[index];
}
